import React, { useState, useContext } from 'react';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import icon_accessibility from "../../../images/234.png";
import CirculationContext from '../../config/CirculationContext';
/**
 * 表尾-公用-英文
 * */
function Common_Footer_En(){

    const ctx = useContext(CirculationContext);
    const [state] = useState({
        
        Last_Update: ctx.Last_Update
    });
     

        return (<div className="footer">
            <div className="container-xxl">
                <div className="linkBox">

                    <div  className="master_footer_en">
                        <br />
                        <div>copyright©2024 Resource Circulation Administration Ministry of Environment</div>
                        <a  href="https://epamail.moenv.gov.tw/front/mailboxhome" target="_blank" title="Contact Us">Contact Us</a>｜
                        <a href="https://www.moenv.gov.tw/en/49AACA21659166DB" target="_blank" title="Privacy and Security Policy">Privacy and Security Policy</a>｜
                        <a href="https://www.moenv.gov.tw/en/6CA206960EF0DAEF" target="_blank" title="Open Government Declaration">Open Government Declaration</a>

                        <div class="d-flex align-middle">
                            <div className="address mt-1 mb-0 mx-auto justify-content-center justify-content-between">
                                <ul className="list-group list-group-horizontal" style={{ 'listStyleType': 'none' }}>
                                    <li className="list-group-item no-border">
                                        <span>First Office</span>
                                        <span>ADD： 8th Floor, No. 83, Sec. 1, Zhonghua Rd., Zhongzheng Dist., Taipei City 100006, Taiwan (R.O.C.)​</span>
                                        <span>TEL  ：886-2-2311-7722​</span></li>
                                </ul>
                            </div>
                        </div>

                        <div class="d-flex align-middle">
                            <div className="address mt-1 mb-2 mx-auto justify-content-center justify-content-between">
                                <ul className="list-group list-group-horizontal" style={{ 'listStyleType': 'none' }}>
                                    <li className="list-group-item no-border">
                                        <span>Second Office</span>
                                        <span>ADD ： 13F, No. 99, Hengyang Rd., Zhongzheng Dist., Taipei City 100005, Taiwan (R.O.C.)​</span>
                                        <span>TEL  ：886-2-2370-5888​</span></li>
                                </ul>
                            </div>
                        </div>

                        <div>Maintained by Industrial Technology Research Institute | TEL：06-3636659</div>
                        <div>Last updated on {state.Last_Update}</div>
                    </div>

                </div>
                <a title="本網站通過無障礙2_A檢測(開啟新視窗)" target="_blank" rel="noopener noreferrer" href="https://accessibility.moda.gov.tw/Applications/Detail?category=20231006100636">
                    <img  src={icon_accessibility} alt="本網站通過無障礙2_A檢測(開啟新視窗)" />
                </a>
            </div></div>);
    
}

export default Common_Footer_En;